import React from 'react'
import { connect } from 'react-redux'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { bindActionCreators } from 'redux'
import {Card, Switch, Row, Col, Input, Icon, notification, Tooltip, Button, Popconfirm, Radio, Spin} from 'antd'
import { changeRestrictedAccess } from 'redux/Ekko/actions'
import { requestDeleteApplication } from '../../redux/appList/actions'
import {changeAuthenticationInChat, changeNowSettingsRequest} from "../../redux/Ekko/actions";
import NowSettings from "./components/NowSettings"

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};

class SettingsApplication extends React.Component {

    onSwitchChange = value => {
        this.props.changeRestrictedAccess(value)
    }

    deleteApplication = () => {
       this.props.requestDeleteApplication()
    }

    changePositionSettings = (e) => {
        const { changeNowSettingsRequest } = this.props

        changeNowSettingsRequest({ position: e.target.value })
    }

    changeBottomOffsetSettings = (e) => {
        const { changeNowSettingsRequest } = this.props

        changeNowSettingsRequest({ bottom_offset: e.target.value })
    }

    changeAuthentication = (e) => {
        this.props.changeAuthenticationInChat(e.target.value)
    }

    render() {
        const { access_token_required, api_key, id } = this.props.currentApp

        return (
            <div>
                <Card title="Settings">
                    <Spin spinning={this.props.loadingCurrentApp} delay={100}>
                        <Row type="flex" justify="space-between" align="middle">
                            <h2>Acces token required</h2>
                            <Switch checked={access_token_required} onChange={this.onSwitchChange} />
                        </Row>
                        <Row>
                            <Col sm={18} xs={24}>
                                <p>
                                    Allow this property will enforce your users to have an access token in order to connect and
                                    use ekko sdk.
                                </p>
                            </Col>
                        </Row>

                        <Row type="flex" justify="space-between" align="middle">
                            <Col sm={12} xs={24}>
                                <h2>APP ID</h2>
                                <Input value={id} suffix={
                                    <CopyToClipboard text={id}  onCopy={() => notification['success']({message: 'Success copy'})}>
                                        <Tooltip placement="bottom" title={"Copy your App Id"}>
                                            <Icon type="copy"/>
                                        </Tooltip>
                                    </CopyToClipboard>
                                }/>
                            </Col>
                        </Row>
                        <Row type="flex" justify="space-between" align="middle" style={{marginTop: "10px"}}>
                            <Col sm={12} xs={24}>
                                <h2>API KEY</h2>
                                <Input.Password value={api_key} />
                            </Col>
                        </Row>

                        <Row type="flex" justify="space-between" align="middle" style={{marginTop: "30px"}}>
                            <Col sm={12} xs={24}>
                                <Popconfirm title="Are you sure to want to delete this application ？" okText="Yes" cancelText="No" onConfirm={this.deleteApplication}>
                                    <Button type="primary">
                                        Delete Application
                                    </Button>
                                </Popconfirm>

                            </Col>
                        </Row>
                    </Spin>
                </Card>

                <Card title="Custom your application">
                    <NowSettings />
                </Card>

            </div>

        )
    }
}

const mapStateToProps = ({ ekko }) => ({
    currentApp: ekko.currentApp,
    loadingCurrentApp: ekko.loadingCurrentApp
})

const mapActionsToProps = dispatch => ({
    changeRestrictedAccess: bindActionCreators(changeRestrictedAccess, dispatch),
    requestDeleteApplication: bindActionCreators(requestDeleteApplication, dispatch),
    changeNowSettingsRequest: bindActionCreators(changeNowSettingsRequest, dispatch),
    changeAuthenticationInChat: bindActionCreators(changeAuthenticationInChat, dispatch),
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(SettingsApplication)
